import './_related-product-options-drawer.scss';
import component from './related-product-options-drawer';

export default component;
